/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState, useEffect } from "react";
import { useGLTF, Plane } from "@react-three/drei";
import { MathUtils, Box3, Vector3 } from 'three';
import { useSpring, a, config } from '@react-spring/three';

export function NodeJS(props) {
    const [isHovered, setIsHovered] = useState(false);
    const currentRotation = useRef(MathUtils.degToRad(-50))
    const [planeSize, setPlaneSize] = useState([1, 1]);
    const groupRef = useRef(); // Reference to the group

    const { rotation } = useSpring({
        from: {
        rotation: currentRotation.current
        },
        config: config.wobbly
    })
    const { nodes, materials } = useGLTF('/models/nodejs_model.glb');

    useEffect(() => {
        if (groupRef.current) {
            const boundingBox = new Box3().setFromObject(groupRef.current);
            const size = new Vector3();
            boundingBox.getSize(size);
            setPlaneSize([size.x + 0.5, size.y + 0.5]); // Update state with the new size
        }
    }, [props.scale]);

    useEffect(() => {
        if(isHovered){
            rotation.start({
                to: currentRotation.current + MathUtils.degToRad(50)
            })
        } else {
            rotation.start({
                to: MathUtils.degToRad(-40)
            })
        }
    }, [isHovered, rotation]);

    return (
    <>
        <Plane
            args={planeSize}
            position={[props.position[0], props.position[1] - 0.24, props.position[2]]}
            onPointerOver={() => setIsHovered(true)}
            onPointerOut={() => setIsHovered(false)}
            visible={props.showBox}
        />
        <a.group {...props}
            dispose={null} 
            ref={groupRef}
            rotation={[0, MathUtils.degToRad(-40), 0]}
            rotation-y={rotation} 
        >
        <mesh
            name="JS"
            castShadow
            receiveShadow
            geometry={nodes.JS.geometry}
            material={materials['SVGMat.001']}
            position={[-1.545, -0.995, 0]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={18.882}
        />
        <mesh
            name="Node"
            castShadow
            receiveShadow
            geometry={nodes.Node.geometry}
            material={materials['SVGMat.003']}
            position={[-1.545, -0.995, 0]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={18.882}
        />
        <mesh
            name="O"
            castShadow
            receiveShadow
            geometry={nodes.O.geometry}
            material={materials['SVGMat.001']}
            position={[-0.416, 0.067, 0]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={0.264}
        />
        <mesh
            name="e_circle"
            castShadow
            receiveShadow
            geometry={nodes.e_circle.geometry}
            material={materials['SVGMat.001']}
            position={[-1.545, -0.995, 0]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={18.882}
        />
        </a.group>
    </>
    )
}

useGLTF.preload('/models/nodejs_model.glb')